import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const AssessmentRecord = ({selectedFormId,data,selectedClientDetails}) => {
   const { t } = useTranslation();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const handleScreenSizeChange = () => setIsSmallScreen(window.innerWidth < 700);

  useEffect(() => {
    handleScreenSizeChange();
    window.addEventListener("resize", handleScreenSizeChange);
    return () => window.removeEventListener("resize", handleScreenSizeChange);
  }, []);
const initialFormData =  {
    Client_Name: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    Sex: "",
    Age: "",
    Session_Date: "",
    Practitioner_Name: "",
    Email: "",
    Type_1_habits: false,
    Type_2_habits: false,
    Type_3_habits: false,
    habit_type: "",
    Principal_Complaints: "",
    Physiological_measurements: "",
    Emotions_Thoughts: "",
    Specific_Triggers: "",
    Motivations_Reinforcements: "",
    Breathing_Challenges: "",
    History_Origins: "",
    Interacting_Conditions: "",
    Problematic_Beliefs: "",
    Learning_Objectives: "",
    Additional_Comments: "",
    Physiological_Checks: {
      PetCO2: false,
      EMG: false,
      HRV: false,
      HR: false,
      SpO2: false,
      Br_min: false,
      BP: false,
      Other: false,
    },
  }
  const [formData, setFormData] = useState(data?.Client_Name?data:initialFormData);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.startsWith("Phys_")) {
      const key = name.replace("Phys_", "");
      setFormData((prev) => ({
        ...prev,
        Physiological_Checks: { ...prev.Physiological_Checks, [key]: checked },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };
const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = () => {
  
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
    session_id: localStorage.getItem("selectedSession") || null,
    
  };

  console.log("📤 Sending form payload test:", payload);

  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const inputStyle = {
    height: "30px",
    padding: "4px",
    backgroundColor: "#f1f4ff",
    borderBottom: "2px solid #444",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    outline: "none",
  };

  const textareaStyle = {
    width: "100%",
    height: "70px",
    border: "2px solid #444",
    backgroundColor: "#f1f4ff",
    padding: "4px",
    marginBottom: "10px",
  };

  return (
    <div 
    style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: "20px auto",
        padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
      }}>
      <h4
        style={{
          color: "#0077b6",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
     
        }}
      >
        ASSESSMENT RECORD
      </h4>

      {/* Client Info */}
      <div style={{ display: "grid", gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr", gap: 10, marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
          <label>Client Name:</label>
          <input name="Client_Name" type="text" disabled={Boolean(selectedClientDetails)} value={formData.Client_Name} onChange={handleInputChange} style={{ ...inputStyle, width: "75%" }} />
        </div>

        <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
          <label>Sex:</label>
          <input name="Sex" type="text" value={formData.Sex} onChange={handleInputChange} style={{ ...inputStyle, width: 30 }} />
          <label>Age:</label>
          <input name="Age" type="text" value={formData.Age} onChange={handleInputChange} style={{ ...inputStyle, width: 30 }} />
          <label>Session Date:</label>
          <input name="Session_Date" type="text" value={formData.Session_Date} onChange={handleInputChange} style={{ ...inputStyle, width: 150 }} />
        </div>

        <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
          <label>Practitioner Name:</label>
          <input name="Practitioner_Name" type="text" value={formData.Practitioner_Name} onChange={handleInputChange} style={{ ...inputStyle, width: "65%" }} />
        </div>

        <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
          <label>Email:</label>
          <input name="Email" type="text" value={formData.Email} onChange={handleInputChange} style={{ ...inputStyle, width: "85%" }} />
        </div>
      </div>

      {/* Breathing Habits */}
     <div>
       <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center",marginBottom:"5px" }}>
        <span style={{ marginRight: 10 }}>Type of breathing habits?</span>
        {["Type_1_habits", "Type_2_habits", "Type_3_habits"].map((type, i) => (
          <div key={type} style={{ display: "flex", alignItems: "center", marginRight: 10 }}>
            <input type="checkbox" name={type} checked={formData[type]} onChange={handleInputChange} />
            <span style={{ marginLeft: 5, color: "#0077b6" }}>
              {`Type ${i + 1} habits`}
              {i === 0 ? " (breathing is regulated)" : i === 1 ? " (breathing regulates)" : " (symptoms regulate)"}
            </span>
          </div>
        ))}
      </div>
        <textarea name="habit_type" value={formData.habit_type} onChange={handleInputChange} style={textareaStyle} />
     </div>
      

      {/* Principal complaints */}
      <div style={{ fontSize: 14, marginBottom: 5 }}>What are the principal complaints, symptoms, and/or deficits associated with the breathing habit(s)?</div>
      <textarea name="Principal_Complaints" value={formData.Principal_Complaints} onChange={handleInputChange} style={textareaStyle} />

      {/* Physiological measurements */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 5 }}>
        <div style={{ fontSize: 14, marginRight: 10 }}>Physiological measurements:</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          {Object.keys(formData.Physiological_Checks).map((key) => (
            <label key={key}>
              <input type="checkbox" name={`Phys_${key}`} checked={formData.Physiological_Checks[key]} onChange={handleInputChange} /> {key}
            </label>
          ))}
          <span style={{ color: "#0077b6", marginLeft: 20 }}>What did you find?</span>
        </div>
      </div>
      <textarea name="Physiological_measurements" value={formData.Physiological_measurements} onChange={handleInputChange} style={textareaStyle} />

      {/* Other Textareas */}
      {[
        ["What emotions and/or thoughts are associated with the breathing habit(s), and/or the physiological changes they mediate?", "Emotions_Thoughts"],
        ["What are the specific triggers (e.g., places, times, people, tasks, situations, thoughts, emotions) of the breathing habit(s)?", "Specific_Triggers"],
        ["What are the motivations (e.g., fear) and reinforcements (e.g., control) perpetuating the breathing habit(s)?", "Motivations_Reinforcements"],
        ["What kind of breathing challenges (e.g., making a phone call, guided overbreathing) did you implement and what were the outcomes?", "Breathing_Challenges"],
        ["What are the history and origins (e.g., asthma as a child, pain issue, pregnancy) of the breathing habit(s)? Provide details.", "History_Origins"],
        ["What are possible interacting organic (e.g., hypertension, neurological disorder) and psychological (e.g., panic) conditions? Provide details.", "Interacting_Conditions"],
        ["Are there problematic client beliefs (bigger breaths mean more O₂) and symptom interpretations (e.g., I'm not getting enough O₂)?", "Problematic_Beliefs"],
        ["In formulating a breathing learning plan for your client, what would be the specific learning objectives (e.g., improving attention)?", "Learning_Objectives"],
        ["ADDITIONAL COMMENTS (e.g., measurement issues, such as metabolic acidosis and PetCO₂ interpretations)", "Additional_Comments"],
      ].map(([label, name]) => (
        <div key={name}>
          <div style={{ fontSize: 14, marginBottom: 5 }}>{label}</div>
          <textarea name={name} value={formData[name]} onChange={handleInputChange} style={textareaStyle} />
        </div>
      ))} 

      {/* Submit */}
        {!data && <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}>{loading?t("Submitting..."):t("Submit")}</button>
      </div>}

      <Modal
                                      isOpen={successModal}
                                      toggle={successToggleModal}
                                      className="connect-box"
                                      centered={true}
                                    >
                                      <ModalHeader toggle={successToggleModal}>
                                        <span className="ml-1 roititle font-weight-bold">
                                          Successfull
                                        </span>
                                      </ModalHeader>
                                      <ModalBody>
                                        <div className="modal-p">
                                          <p>Trainer form has been submitted successfully.</p>
                                        </div>
                                      </ModalBody>
                                    </Modal>
    </div>
  );
};

export default AssessmentRecord;
